/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../connect/v2/common/sort';
import '../../common/sort_fields';
import '../../common/locale';
import '../../resources/product';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "SearchProductsSort": {
                    "fields": {
                      "sortOrder": {
                        "type": "squareup.connect.v2.common.SortOrder",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": "ASC"
                        }
                      },
                      "sortField": {
                        "type": "squareup.solidshop.v2.common.ProductSortField",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "PRODUCT_KEY"
                        }
                      }
                    }
                  },
                  "SearchProductsFilter": {
                    "fields": {
                      "productKeys": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "productTaxonKeys": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "productName": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "onlyFeatured": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "SearchProductsQuery": {
                    "fields": {
                      "sort": {
                        "type": "squareup.solidshop.v2.service.SearchProductsSort",
                        "id": 1,
                        "rule": "optional"
                      },
                      "filter": {
                        "type": "squareup.solidshop.v2.service.SearchProductsFilter",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "SearchProductsRequest": {
                    "fields": {
                      "query": {
                        "type": "squareup.solidshop.v2.service.SearchProductsQuery",
                        "id": 1,
                        "rule": "optional"
                      },
                      "limit": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": 100
                        }
                      },
                      "cursor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "locale": {
                        "type": "squareup.solidshop.v2.common.Locale",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": "EN_US"
                        }
                      }
                    }
                  },
                  "SearchProductsResponse": {
                    "fields": {
                      "products": {
                        "type": "squareup.solidshop.v2.resources.Product",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "cursor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SearchProductsSort && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SearchProductsFilter && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SearchProductsQuery && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SearchProductsRequest && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.SearchProductsResponse) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE SearchProductsSort @ squareup/solidshop/v2/service/products/search_products.proto at 14:1
 */
export const SearchProductsSort = $root.lookupType('squareup.solidshop.v2.service.SearchProductsSort');
fixType(SearchProductsSort);
Builder.createAndAttachToType(SearchProductsSort);
/**
 * SOURCE SearchProductsFilter @ squareup/solidshop/v2/service/products/search_products.proto at 22:1
 */
export const SearchProductsFilter = $root.lookupType('squareup.solidshop.v2.service.SearchProductsFilter');
fixType(SearchProductsFilter);
Builder.createAndAttachToType(SearchProductsFilter);
/**
 * SOURCE SearchProductsQuery @ squareup/solidshop/v2/service/products/search_products.proto at 39:1
 */
export const SearchProductsQuery = $root.lookupType('squareup.solidshop.v2.service.SearchProductsQuery');
fixType(SearchProductsQuery);
Builder.createAndAttachToType(SearchProductsQuery);
/**
 * SOURCE SearchProductsRequest @ squareup/solidshop/v2/service/products/search_products.proto at 47:1
 */
export const SearchProductsRequest = $root.lookupType('squareup.solidshop.v2.service.SearchProductsRequest');
fixType(SearchProductsRequest);
Builder.createAndAttachToType(SearchProductsRequest);
/**
 * SOURCE SearchProductsResponse @ squareup/solidshop/v2/service/products/search_products.proto at 61:1
 */
export const SearchProductsResponse = $root.lookupType('squareup.solidshop.v2.service.SearchProductsResponse');
fixType(SearchProductsResponse);
Builder.createAndAttachToType(SearchProductsResponse);
